// export interface CreateOrderPayload {
//   cart: CartPayload;
//   customer: CustomerPayload | null;
// }

/**
 * @typedef CustomerPayload
 * @type {Object}
 */

/**
 * @typedef CreateOrderPayload
 * @type {Object}
 * @property {ShopifyCartData} cart - The cart payload.
 * @property {CustomerPayload|null} customer - The customer payload.
 */


/**
 * A custom element that represents a checkout button.
 * @class SmarchCheckoutButton
 * @extends HTMLElement
 * @example
 * <smarch-checkout-button></smarch-checkout-button>
 *
 * @example
 * const checkoutButton = document.querySelector('smarch-checkout-button');
 * checkoutButton.smarchCheckout(checkoutButton);
 *
 **/
class SmarchCheckoutButton extends HTMLElement {
  constructor () {
    super();

  }

  /**
   * Check if cart has subscription items.
   * @param {Array<CartLineItem>} items - The items in the cart.
   * @returns Promise<boolean> - Whether the cart has subscription items.
   */

  async cartHasSubscriptionItems ({ items } ) {
    if (!items) return false;

    const testPaketItems = items.filter(item => item.title.includes('Testpaket:30 kaffekapslar + kapselhållare'));

    console.log('testPaketItems', testPaketItems);
    return testPaketItems.length > 1;
  };

  /**
   * Fetches items in the Shopify cart.
   * @async
   * @function fetchCart
   * @returns {Promise<ShopifyCartData>} The items in the Shopify cart.
   *
   * @example
   * const cartItems = await fetchCartItems();
   * console.log(cartItems);
   *
   */
  async fetchCart () {
    // Your fetch logic here. For example:
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      return null
    }

    return response.json();
  }



  /**
   * Calls a cloud function to perform the actual checkout.
   * @param {CreateOrderPayload} payload - The cart data.
   * @function performCheckout
   * @returns {Promise<{ checkoutURL: string } | { error: string }>} The checkout response.
   *
   */
  async performCheckout (payload) {

    const functionURl = "https://v2shopifystorefrontcreateorder-flffhnvixa-uc.a.run.app";

    const response = await fetch(functionURl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Cors-Origin': '*'
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  /**
   * Gets the value of a cookie by name.
   * @function getCookie
   * @param {string} name - The name of the cookie to retrieve.
   * @returns {string|null} The value of the cookie, or null if not found.
   */
  getCookie (name) {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }

    return null;
  }

  /**
   * Initiates the checkout process.
   * @param {HTMLElement} checkoutButton - The checkout button.
   * @returns {Promise<void>}
   */
  async smarchCheckout (checkoutButton) {
    function startAnimation () {
  
      checkoutButton.disabled = true;
    }

    function stopAnimation () {
   

      checkoutButton.disabled = false;
    }

    startAnimation();

    try {

      const cart = await this.fetchCart();
      const cookieInfo = JSON.parse(localStorage.getItem('bundle_info'));
      const hasSubscriptionItems = await this.cartHasSubscriptionItems(cart);

      if (hasSubscriptionItems) {
        stopAnimation();
        alert('Du har en prenumeration i varukorgen. Vänligen gå till varukorgen för att slutföra din beställning.');
        return;
      }
    
      if(cookieInfo){
        let variantIdFromCookie = parseInt(cookieInfo[0].productId.split('/').pop(), 10);
        let subscription = true; 
        // Find the item in the cart that matches the variant ID
        let matchingItem = cart.items.find(item => item.variant_id === variantIdFromCookie);

        if (matchingItem) {
          if(cookieInfo[0].subscription == '') {
               subscription = false;
              sessionStorage.setItem('checkoutVisited', true);
            window.location.href = '/checkout';
         
            return;
          }
            // Add the bundleConfig to the matching item
            matchingItem.bundleConfig = {
                "subscriptionInterval": cookieInfo[0].subscription,
                "bundleID": cookieInfo[0].bundleId
            };
        }
      } else {
              sessionStorage.setItem('checkoutVisited', true);
        window.location.href = '/checkout';
        return;
      }
     

      let customer = null;
      if (window._smarch && window._smarch.customer) {
        console.log('Customer Data:', window._smarch.customer);
        customer = window._smarch.customer;
        // Use window._smarch.customer as needed in your script
      } else {
        console.log('No customer data available.');
      }

      // Get the ReferralID cookie
      const referralCode = this.getCookie('coffyref');

      // Get Facebook cookies
      const fbp = this.getCookie("_fbp");
      const fbc = this.getCookie("_fbc");
 
      const checkoutResponse = await this.performCheckout({
        cart: cart,
        customer: customer,
        referralCode,
        fbp,
        fbc,
      });

      console.log("checkoutResponse", checkoutResponse);
      stopAnimation();

      if (checkoutResponse.error) {
        console.error('Checkout failed! Check console for error.');
        return;
      }

      if (checkoutResponse.checkoutURL) {
        localStorage.removeItem('bundle_info');
        await this.clearCart();
        
        window.location.href = checkoutResponse.checkoutURL;
      }
    } catch (error) {
      console.error(error);
      stopAnimation();
      console.error('Checkout failed! Check console for error.');
    }
  }

  /**
   * Clears the Shopify cart.
   * @async
   * @function clearCart
   * @returns {Promise<Object>} The response after clearing the cart.
   */
  async clearCart () {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  /**
   * Lifecycle method that runs when the element is connected to the DOM.
   * @function connectedCallback
   * @returns {void}
   */
  connectedCallback () {
    this.button = this.querySelector('button');
    this.button.addEventListener('click', () => {
			event.preventDefault();
			this.smarchCheckout(this.button).then(r => console.log(r));
    });
  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  removeCookie(cookieName) {
    // Set the cookie with the same name and path, but with an expired date
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
}

// Define the custom element.
customElements.define('smarch-checkout-button', SmarchCheckoutButton);


